import React, { Component } from 'react';
import { Collapse, Progress, Alert } from 'reactstrap';
import Profile from './Profile';
import ChildItems from './ChildItems';
import Confirmation from './Confirmation';
import BackButton from '../BackButton';

export default class ProfileMain extends Component {
    constructor(props) {
        super(props)

        this.state = {
            googleId: null,
            profiles: {},
            governmentPositions: [],
            communityActivities: [],
            contracts: [],
            education: [],
            employment: [],
            financialInterests: [],            
            licensesCertificates: [],
            references: [],
            progressPercentage: 0,
            editMode: false,
            unsavedChanges: false
        };
    }

    beautifyData = (data) => {
        for (var key in data) {
            //convert boolean values to strings in order to incorporate into radio buttons and progress logic
            if (data[key] === true || data[key] === false) {
                data[key] = data[key].toString();
            }
            //remove timestamp from date values
            if (Object.prototype.toString.call(data[key]) === "[object String]" && key.includes("Date")) {
                data[key] = data[key].substring(0, data[key].indexOf('T'));
            }
            //recurse
            if (Object.prototype.toString.call(data[key]) === "[object Array]" ) {
                this.beautifyData(data[key]);
            }
            if (Object.prototype.toString.call(data[key]) === "[object Object]") {
                this.beautifyData(data[key]);
            }
        }
        return data;
    }
    componentDidMount() {
        this.setState({ isProfileOpen: true })
        document.getElementById('Profile').classList.add('active');

        fetch('api/login?token=' + sessionStorage.getItem("token"), {
            method: 'GET'
        })
            .then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        if (!data.googleId) {
                            alert('Google sign in could not complete authentication.  Please sign in to authenticate.');
                            this.props.history.push('/signin');
                        } else {
                            this.props.history.push('/profile/' + data.googleId);
                            this.setState({ googleId: data.googleId }, this.updateProfile);                            
                        }
                    })
                } else {
                    alert('There was an error in the sign in process.  Please try again at a later time.');
                }
            })   
    }

    updateProfile = () => {
        fetch('api/profiles/GetProfileByGoogleId/' + this.state.googleId, {
            method: 'GET'
        })
        .then(response => {
            if (response.ok) {
                response.json().then(data => {
                    data = this.beautifyData(data);
                    this.setState({
                        profiles: data,
                        governmentPositions: data.governmentPositionsNavigation,
                        communityActivities: data.communityActivitiesNavigation,
                        contracts: data.contractsNavigation,
                        education: data.educationNavigation,
                        employment: data.employmentNavigation,
                        financialInterests: data.financialInterestsNavigation,
                        licensesCertificates: data.licensesCertificatesNavigation,
                        references: data.referencesNavigation,
                        editMode: true
                    }, this.calculateProgress)
                })
            }
        })  
    }

    calculateProgress = () => {
        let inputElements = document.getElementsByClassName('includeInProgress');
        let prevName = "";
        let numeratorCount = 0;
        let denominatorCount = 0;        

        for (let i = 0; i < inputElements.length; i++) {
            let type = inputElements[i].type;
            let name = inputElements[i].name;
            let value = inputElements[i].value;
            let valid = inputElements[i].validity.valid;
            let form = inputElements[i].form.id;
            let required = inputElements[i].required;
            //count of total required input fields
            if (name !== prevName && required === true) { 
                //radio button with multiple options will have two elements with the same name, only include one in the denominator
                denominatorCount++;                
            }
            //count of fields user has currently completed
            if
                (
                    ((type === "text" || type === "date" || type === "select-one") && required && value)
                    || 
                    (type === "radio" && form === "profile" && name !== prevName && required && valid)
                    ||
                    (name !== prevName && name === "governmentPositions" && valid &&
                        (
                        (this.state.profiles.governmentPositions === "false") ||
                        (this.state.profiles.governmentPositions === "true" && this.state.governmentPositions.length > 0)
                        )
                    )
                    ||
                    (name !== prevName && name === "licensesCertificates" && valid &&
                        (
                        (this.state.profiles.licensesCertificates === "false") ||
                        (this.state.profiles.licensesCertificates === "true" && this.state.licensesCertificates.length > 0)
                        )
                    )
                    ||
                    (name !== prevName && name === "communityActivities" && valid &&
                        (
                            (this.state.profiles.communityActivities === "false") ||
                            (this.state.profiles.communityActivities === "true" && this.state.communityActivities.length > 0)
                        )
                    )
                    ||
                    (name !== prevName && name === "education" && valid &&
                        (
                            (this.state.profiles.education === "false") ||
                            (this.state.profiles.education === "true" && this.state.education.length > 0)
                        )
                    )
                    ||
                    (name !== prevName && name === "employment" && valid &&
                    (
                            (this.state.profiles.employment === "false") ||
                            (this.state.profiles.employment === "true" && this.state.employment.length > 0)
                        )
                    )
                    ||
                    (name !== prevName && name === "references" && valid &&
                        (
                            (this.state.profiles.references === "false") ||
                            (this.state.profiles.references === "true" && this.state.references.length > 0)
                        )
                    )
                    ||
                    (name !== prevName && name === "contracts" && valid &&
                        (
                            (this.state.profiles.contracts === "false") ||
                            (this.state.profiles.contracts === "true" && this.state.contracts.length > 0)
                        )
                    )
                    ||
                    (name !== prevName && name === "financialInterests" && valid &&
                        (
                            (this.state.profiles.financialInterests === "false") ||
                            (this.state.profiles.financialInterests === "true" && this.state.financialInterests.length > 0)
                        )
                    )
                )

            {
                numeratorCount++;
            }
            prevName = name;
        }
        this.setState({ progressPercentage: numeratorCount === 0 ? 0 : Math.round((numeratorCount / denominatorCount) * 100) });        
    }

    navClick = (e, newSection) => {
        let lis = document.querySelectorAll('ul.navProfile > div > li');
        for (let i = 0; i < lis.length; i++) {
            if (lis[i].id === (newSection || e.target.id)) {
                lis[i].classList.add('active');
                this.setState({ ["is" + (newSection || e.target.id) + "Open"]: true })
            } else {
                lis[i].classList.remove('active');
                this.setState({ ["is" + lis[i].id + "Open"]: false })
            }
        }

        this.calculateProgress();
    }

    handleChange = (e, table) => {
        let intValue = e.target.value;

        if (Number.isInteger(intValue)) {
            table[e.target.name] = parseFloat(intValue);
        } else {
            table[e.target.name] = intValue;
        }
        this.setState({ [table]: table }, this.calculateProgress);

        // when radio buttons are selected, remove class that styles radio button as required / invalid
        if (e.target.type === "radio" && e.target.required) {
            document.getElementById(e.target.name + "Radio").classList.remove('required-radio');
        }

        //trigger unsavedChanges notice to user if in edit mode
        if (this.state.editMode) {
            this.setState({ unsavedChanges: true })
        }
    }

    handleSave = () => {
        fetch('api/profiles/' + this.state.profiles.id, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.profiles)
        })
            .then(response => {
                if (response.ok) {
                    this.setState({ unsavedChanges: false })
                } else {
                    response.json().then(data => {
                        this.setState({ submitError: true, alertMessage: data })
                    })
                }
            })    
        this.setState({ unsavedChanges: false })
    }

    removeIdFromJson = (key, value) => {
        if (key === "id") {
            return undefined;
        } else {
            return value;
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let profiles = this.state.profiles;
        profiles["googleId"] = this.state.googleId;
        profiles = JSON.stringify(this.state.profiles);

        let governmentPositions = JSON.stringify([...this.state.governmentPositions], this.removeIdFromJson);
        let licensesCertifications = JSON.stringify([...this.state.licensesCertificates], this.removeIdFromJson);
        let communityActivities = JSON.stringify([...this.state.communityActivities], this.removeIdFromJson);
        let education = JSON.stringify([...this.state.education], this.removeIdFromJson);
        let employment = JSON.stringify([...this.state.employment], this.removeIdFromJson);
        let references = JSON.stringify([...this.state.references], this.removeIdFromJson);
        let contracts = JSON.stringify([...this.state.contracts], this.removeIdFromJson);
        let financialInterests = JSON.stringify([...this.state.financialInterests], this.removeIdFromJson);          

        let formData = new FormData();
        formData.append('profiles', profiles);
        formData.append('governmentPositions', governmentPositions);
        formData.append('licensesCertifications', licensesCertifications);
        formData.append('communityActivities', communityActivities);
        formData.append('education', education);
        formData.append('employment', employment);
        formData.append('references', references);
        formData.append('contracts', contracts);
        formData.append('financialInterests', financialInterests);

        fetch('api/profiles', {
            method: 'POST',
            headers: {
                'Accept': 'application/json'
            },
            body: formData
        })
            .then(response => {
                if (response.ok) {
                    this.navClick(null, "Confirmation");
                } else {
                    response.json().then(data => {
                        this.setState({ submitError: true, alertMessage: data})
                    })
                }
            })            
    }

    updateChildItems = (childTable, childItems) => {
        this.setState({ [childTable]: childItems }, this.calculateProgress);
    }

    goToDashboard = () => {
        this.props.history.push('/dashboard/' + this.state.googleId);
    }

    render() {      
        return (        
            <div>     
                <div className="container form-border">
                    {this.state.submitError &&
                        <Alert color="danger">
                            <h4 className="alert-heading">Submission Error</h4>
                            <hr />
                            {this.state.alertMessage}
                        </Alert>
                    }
                    {this.state.unsavedChanges &&
                        <div>
                            <Alert className="text-center" color="danger">
                                <p>You have unsaved changes.  Please click the "Save" button in order to save your changes.</p>                      
                            </Alert>                            
                        </div>
                    }
                    {!this.state.editMode && 
                        <Alert className="text-center" color="secondary">
                            Please complete your profile in order to apply for a St. Louis County Board or Commission
                        </Alert>
                    }
                    {this.state.editMode &&
                        <BackButton navTitle="Dashboard" onClickBack={this.goToDashboard} />
                    }
                    <div>
                        <div className="text-center">Progress: {this.state.progressPercentage}%</div>
                        <Progress value={this.state.progressPercentage} color="success" />
                    </div>
                    <br />
                    <ul className="navProfile nav nav-pills nav-fill flex-column">

                        <Collapse isOpen={this.state.isProfileOpen}>
                            <li id="Profile" className="nav-item nav-link" onClick={(e) => this.navClick(e)}>
                                Contact Information
                            </li>                                
                            <Profile
                                id={this.state.id}
                                onChange={(e) => this.handleChange(e, this.state.profiles)}
                                onClickNext={(e) => this.navClick(e, "GovernmentPositions")}
                                calculateProgress={this.calculateProgress}
                                profiles={this.state.profiles}
                                editMode={this.state.editMode}
                                unsavedChanges={this.state.unsavedChanges}
                                onSaveChanges={this.handleSave}
                            />
                        </Collapse>
                            
                        <Collapse isOpen={this.state.isGovernmentPositionsOpen}>
                            <li id="GovernmentPositions" className="nav-item nav-link" onClick={(e) => this.navClick(e)}>
                                Government Positions
                            </li>                            
                            <ChildItems
                                id={this.state.id}
                                onRadioChange={(e) => this.handleChange(e, this.state.profiles)}
                                profiles={this.state.profiles}
                                governmentPositions={this.state.governmentPositions}
                                onClickNext={(e) => this.navClick(e, "LicensesCertificates")} next={true}
                                onClickBack={(e) => this.navClick(e, "Profile")} back={true}                                
                                updateChildItems={this.updateChildItems}
                                calculateProgress={this.calculateProgress}
                                childTable="governmentPositions"
                                modalHeader="Add a Government Position"
                                questionLabel="Do you currently hold, or have you previously held, any local, state or federal government positions,
                                              appointments or elected office(s)?"
                                keyItem="position"
                                editMode={this.state.editMode}
                                unsavedChanges={this.state.unsavedChanges}
                                onSaveChanges={this.handleSave}
                                updateProfile={this.updateProfile}
                            />                            
                        </Collapse>

                        <Collapse isOpen={this.state.isLicensesCertificatesOpen}>
                            <li id="LicensesCertificates" className="nav-item nav-link" onClick={(e) => this.navClick(e)}>
                                Licenses and Certificates
                            </li>
                            <ChildItems
                                id={this.state.id}
                                onRadioChange={(e) => this.handleChange(e, this.state.profiles)}
                                profiles={this.state.profiles}
                                licensesCertificates={this.state.licensesCertificates}
                                onClickNext={(e) => this.navClick(e, "CommunityActivities")} next={true}
                                onClickBack={(e) => this.navClick(e, "GovernmentPositions")} back={true}
                                updateChildItems={this.updateChildItems}
                                calculateProgress={this.calculateProgress}
                                childTable="licensesCertificates"
                                modalHeader="Add a License or Certificate"
                                questionLabel="Do you currently hold any professional licenses or certificates, not limited to Missouri?"
                                keyItem="name"
                                editMode={this.state.editMode}
                                unsavedChanges={this.state.unsavedChanges}
                                onSaveChanges={this.handleSave}
                                updateProfile={this.updateProfile}
                            /> 
                        </Collapse>

                        <Collapse isOpen={this.state.isCommunityActivitiesOpen}>
                            <li id="CommunityActivities" className="nav-item nav-link" onClick={(e) => this.navClick(e)}>
                                Community Activities
                            </li>
                            <ChildItems
                                id={this.state.id}
                                onRadioChange={(e) => this.handleChange(e, this.state.profiles)}
                                profiles={this.state.profiles}
                                communityActivities={this.state.communityActivities}
                                onClickNext={(e) => this.navClick(e, "Education")} next={true}
                                onClickBack={(e) => this.navClick(e, "LicensesCertificates")} back={true}
                                updateChildItems={this.updateChildItems}
                                calculateProgress={this.calculateProgress}
                                childTable="communityActivities"
                                modalHeader="Add a Community Activity"
                                questionLabel="Are you currently involved in any significant community and professional associations?"
                                keyItem="organization"
                                editMode={this.state.editMode}
                                unsavedChanges={this.state.unsavedChanges}
                                onSaveChanges={this.handleSave}
                                updateProfile={this.updateProfile}
                            /> 
                        </Collapse>
                            
                        <Collapse isOpen={this.state.isEducationOpen}>
                            <li id="Education" className="nav-item nav-link" onClick={(e) => this.navClick(e)}>
                                Education
                            </li>
                            <ChildItems
                                id={this.state.id}
                                onRadioChange={(e) => this.handleChange(e, this.state.profiles)}
                                profiles={this.state.profiles}
                                education={this.state.education}
                                onClickNext={(e) => this.navClick(e, "Employment")} next={true}
                                onClickBack={(e) => this.navClick(e, "CommunityActivities")} back={true}
                                updateChildItems={this.updateChildItems}
                                handleSubmit={(e) => this.handleSubmit(e)}
                                calculateProgress={this.calculateProgress}
                                childTable="education"
                                modalHeader="Add an Education Degree"
                                questionLabel="Do you hold any higher education degrees?"
                                keyItem="degree"
                                editMode={this.state.editMode}
                                unsavedChanges={this.state.unsavedChanges}
                                onSaveChanges={this.handleSave}
                                updateProfile={this.updateProfile}
                            /> 
                        </Collapse>
                            
                        <Collapse isOpen={this.state.isEmploymentOpen}>
                            <li id="Employment" className="nav-item nav-link" onClick={(e) => this.navClick(e)}>
                                Employment
                            </li>
                            <ChildItems
                                id={this.state.id}
                                onRadioChange={(e) => this.handleChange(e, this.state.profiles)}
                                profiles={this.state.profiles}
                                employment={this.state.employment}
                                onClickNext={(e) => this.navClick(e, "References")} next={true}
                                onClickBack={(e) => this.navClick(e, "Education")} back={true}
                                updateChildItems={this.updateChildItems}
                                handleSubmit={(e) => this.handleSubmit(e)}
                                calculateProgress={this.calculateProgress}
                                childTable="employment"
                                modalHeader="Add Employment History"
                                questionLabel="Do you have any employment history?"
                                keyItem="title"
                                editMode={this.state.editMode}
                                unsavedChanges={this.state.unsavedChanges}
                                onSaveChanges={this.handleSave}
                                updateProfile={this.updateProfile}
                            /> 
                        </Collapse>                      

                        <Collapse isOpen={this.state.isReferencesOpen}>
                            <li id="References" className="nav-item nav-link" onClick={(e) => this.navClick(e)}>
                                References
                            </li>
                            <ChildItems
                                id={this.state.id}
                                onRadioChange={(e) => this.handleChange(e, this.state.profiles)}
                                profiles={this.state.profiles}
                                references={this.state.references}
                                onClickNext={(e) => this.navClick(e, "Contracts")} next={true}
                                onClickBack={(e) => this.navClick(e, "Employment")} back={true}
                                updateChildItems={this.updateChildItems}
                                handleSubmit={(e) => this.handleSubmit(e)}
                                calculateProgress={this.calculateProgress}
                                childTable="references"
                                modalHeader="Add References"
                                questionLabel="Do you have any References?"
                                keyItem="name"
                                editMode={this.state.editMode}
                                unsavedChanges={this.state.unsavedChanges}
                                onSaveChanges={this.handleSave}
                                updateProfile={this.updateProfile}
                            /> 
                        </Collapse>   

                        <Collapse isOpen={this.state.isContractsOpen}>
                            <li id="Contracts" className="nav-item nav-link" onClick={(e) => this.navClick(e)}>
                                Contracts
                            </li>
                            <ChildItems
                                id={this.state.id}
                                onRadioChange={(e) => this.handleChange(e, this.state.profiles)}
                                profiles={this.state.profiles}
                                contracts={this.state.contracts}
                                onClickNext={(e) => this.navClick(e, "FinancialInterests")} next={true}
                                onClickBack={(e) => this.navClick(e, "References")} back={true}
                                updateChildItems={this.updateChildItems}                                
                                calculateProgress={this.calculateProgress}
                                childTable="contracts"
                                modalHeader="Add Contracts"
                                questionLabel="Do you, or does anyone in your family, have any contracts with St. Louis County 
                                              (or have an ownership interest in any entity or group which has a contract with St. Louis County),
                                              for the performance of any services; provision of any goods; or the sale or lease of any property?"
                                keyItem="name"
                                editMode={this.state.editMode}
                                unsavedChanges={this.state.unsavedChanges}
                                onSaveChanges={this.handleSave}
                                updateProfile={this.updateProfile}
                            />
                        </Collapse>   

                        <Collapse isOpen={this.state.isFinancialInterestsOpen}>
                            <li id="FinancialInterests" className="nav-item nav-link" onClick={(e) => this.navClick(e)}>
                                Financial Interests
                            </li>
                            <ChildItems
                                id={this.state.id}
                                onRadioChange={(e) => this.handleChange(e, this.state.profiles)}
                                profiles={this.state.profiles}
                                financialInterests={this.state.financialInterests}
                                onClickBack={(e) => this.navClick(e, "Contracts")} back={true}
                                next={false}
                                handleSubmit={(e) => this.handleSubmit(e)}                                                                                                
                                updateChildItems={this.updateChildItems}
                                calculateProgress={this.calculateProgress}
                                childTable="financialInterests"
                                modalHeader="Add a Financial Interest"
                                questionLabel="Do you have any financial or other interest that might present a conflict of interest, 
                                               or the appearance of such a conflict,
                                               if you were appointed to the position for which you have applied?"
                                keyItem="interest"    
                                editMode={this.state.editMode}
                                unsavedChanges={this.state.unsavedChanges}
                                onSaveChanges={this.handleSave}
                                updateProfile={this.updateProfile}
                            />
                        </Collapse>                             

                        <Collapse isOpen={this.state.isConfirmationOpen}>
                            <li id="Confirmation" className="nav-item nav-link">
                                Profile Submission Confirmation
                            </li>
                            <Confirmation
                                goToDashboard={this.goToDashboard}
                            />
                        </Collapse>
                    </ul>
                </div>
            </div>           
        )
    }
}